let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("4C2Hh"), load("cQL1E"), load("MrUJ0"), load("2u53D"), load("hMDX9"), load("fOegz")]).then(() => parcelRequire('hiMwI'));